import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const isConfigured =
  !!firebaseConfig.apiKey && !!firebaseConfig.projectId && !!firebaseConfig.appId;

let app = null;
let messagingPromise = null;

if (isConfigured) {
  app = initializeApp(firebaseConfig);
  // getMessaging throws on unsupported environments (e.g. some Safari, in-app webviews).
  messagingPromise = isSupported()
    .then((ok) => (ok ? getMessaging(app) : null))
    .catch(() => null);
}

export const firebaseConfigured = isConfigured;
export const getMessagingInstance = async () => (messagingPromise ? messagingPromise : null);

// The FCM service worker can't read env vars, so we hand it the same config via
// query params (these values are public — safe in a URL). This keeps the worker
// and the page on a single source of truth and prevents the two from drifting.
export const fcmServiceWorkerUrl = () => {
  const qs = new URLSearchParams({
    apiKey: firebaseConfig.apiKey || "",
    authDomain: firebaseConfig.authDomain || "",
    projectId: firebaseConfig.projectId || "",
    storageBucket: firebaseConfig.storageBucket || "",
    messagingSenderId: firebaseConfig.messagingSenderId || "",
    appId: firebaseConfig.appId || "",
  });
  return `/firebase-messaging-sw.js?${qs.toString()}`;
};
